"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Single = function Single(_ref) {
  var _ref$data = _ref.data,
    video = _ref$data.video,
    shadowImage = _ref$data.shadowImage,
    textDecoration = _ref$data.text_decoration,
    image = _ref$data.image,
    decorationPosition = _ref$data.decoration_position,
    inView = _ref.inView;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row text-decoration-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative video-modal-player mb40 d8-u-shadow-xl d8-u-radius-md"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "aspect-16-9 d8-u-radius-md"
  }, video && /*#__PURE__*/_react["default"].createElement("iframe", {
    style: {
      width: '100%'
    },
    title: "Video",
    src: video,
    frameBorder: "0",
    allow: "autoplay; encrypted-media",
    webkitallowfullscreen: "true",
    mozallowfullscreen: "true"
  }), image && /*#__PURE__*/_react["default"].createElement("img", {
    className: "d8-u-radius-md",
    src: inView ? image.url : '',
    alt: textDecoration
  }), shadowImage && /*#__PURE__*/_react["default"].createElement("img", {
    src: inView ? shadowImage : '',
    className: "shadow-image max-width d8-u-radius-md",
    alt: textDecoration
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "absolute text-decoration ".concat(decorationPosition || '')
  }, /*#__PURE__*/_react["default"].createElement("strong", null, textDecoration)))));
};
Single.propTypes = {
  data: _propTypes["default"].object.isRequired,
  inView: _propTypes["default"].bool
};
var _default = exports["default"] = Single;